const LOG_START = Date.now()
const LOG_WITH_TIME = true

function SecondsToString(t) {
  if (t < 0) {
    return '0:00'
  } else {
    return (
      Math.floor(t / 60).toString() +
      ':' +
      Math.floor(t % 60)
        .toString()
        .padStart(2, '0')
    )
  }
}

function SignedSecondsToString(t) {
  const x = Math.floor(t + 0.5)
  if (x === 0) {
    return 0
  } else {
    const xs = x.toString()
    if (x > 0) {
      return '+' + xs
    } else {
      return xs
    }
  }
}

var logBlockingModule = null

function log(m, ...o) {
  var caller = 'unknown'
  try {
    caller = new Error().stack.split('\n')[2].trim().split(' ')[1]
  } catch (e) {}
  if (logBlockingModule) {
    if (caller.indexOf(logBlockingModule) !== 0) {
      return
    }
  }
  var timePrefix = ''
  if (LOG_WITH_TIME) {
    timePrefix =
      '[' + (Date.now() - LOG_START).toString().padStart(6, '0') + '] '
  }
  console.log(`${timePrefix}${caller}: ` + m)
  if (o) {
    for (var oo of o) {
      console.dir(oo)
    }
  }
}

function onlyLog(me) {
  var module = me
  if (!module) {
    var caller = 'unknown'
    try {
      caller = new Error().stack.split('\n')[2].trim().split(' ')[1]
    } catch (e) {}
    if (caller !== 'unknown') {
      module = caller.split('.')[0]
    }
  }
  if (module) {
    // log('Blocking out all other modules' logging in favour of: '+module);
    logBlockingModule = module
  }
}

function noLog() {} /// use 'import {noLog as log}' to suppress logging noise

function openWindow(url) {
  log('sending to background.js message to open: ' + url)
  chrome.runtime?.sendMessage({ type: 'openWindow', url: url }, response => {
    if (response.error) {
      console.error('error handling openWindow')
    } else {
      log('yay, openWindow acknowledged')
    }
  })
}

function EpochToPrettyDate(e) {
  const d = new Date(e * 1000)
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  return d.getDate() + ' ' + MONTHS[d.getMonth()]
}

function EpochToPrettyDateHoursMinutes(e) {
  const d = new Date(e * 1000)
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  var hours = d.getHours()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  return (
    (hours < 13 ? hours : hours % 12) +
    ':' +
    d.getMinutes().toString().padStart(2, '0') +
    ' ' +
    ampm +
    ' ' +
    _orderedNumbers(d.getDate()) +
    ' ' +
    MONTHS[d.getMonth()]
  )
}

function _orderedNumbers(x) {
  const mod = x % 10
  if (mod === 1) {
    return x + 'st'
  } else if (mod === 2) {
    return x + 'nd'
  } else if (mod === 3) {
    return x + 'rd'
  }
  return x + 'th'
}

function getTZOffset() {
  return new Date().getTimezoneOffset()
}

function eventTargetName(e) {
  var target = null
  if (e.toElement && e.toElement.name) {
    target = e.toElement.name
  }
  if (!target) {
    try {
      target = e.target.name
      if (target) {
        // log("Target name found! " + target);
      }
    } catch (e) {}
  }
  if (!target && e.type && e.type === 'click') {
    console.error('No target name found on click: ', e)
  }
  return target
}

function GetUserAgent() {
  try {
    return navigator.userAgent
  } catch (e) {
    console.error('Cannot detect User Agent!', e)
  }
}

export {
  EpochToPrettyDate,
  EpochToPrettyDateHoursMinutes,
  eventTargetName,
  GetUserAgent,
  getTZOffset,
  log,
  noLog,
  onlyLog,
  openWindow,
  SecondsToString,
  SignedSecondsToString
}
